// eslint-disable-next-line import/no-unresolved
import { Dimensions } from "react-native";

const dims = Dimensions.get("window");
const isLandscape = dims.width >= dims.height;

// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export default () => isLandscape;
